import { buildAxiosErrorMessage } from '@/utils/buildAxiosErrorMessage'
import * as Sentry from '@sentry/react'
import axios from 'axios'
import { setupAuthInterceptor } from './axios.interceptors'

export const axiosHub = axios.create({
  timeout: 20000,
  baseURL: import.meta.env.VITE_URL_HUB_API,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Setup auth interceptor
setupAuthInterceptor(axiosHub)

// Error handling interceptor
axiosHub.interceptors.response.use(undefined, error => {
  const errorMessage = buildAxiosErrorMessage(error, 'Hub Server Error')
  console.error(errorMessage)
  Sentry.captureException(errorMessage)
})
